import { useState } from "react";

const ClientBar = ({
  clients = [],
  selectedClient = null,
  onClientChange,
  onToggleAvailability,
  onLiveCounter,
}) => {
  const [open, setOpen] = useState(false);

  const isClientAvailable = selectedClient?.isAvailable;

  return (
    <div className="bg-white px-2 py-1 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 w-full md:w-auto">
        <span className="text-xs font-semibold text-gray-600 whitespace-nowrap">Client</span>

        <div className="relative w-72">
          <button
            onClick={() => setOpen((v) => !v)}
            className="
              w-full
              flex items-center justify-between
              px-2 py-0.5
              border border-gray-300
              rounded
              bg-white
              text-left
              text-xs
              text-gray-800
              font-medium
              hover:border-gray-400
              focus:outline-none
            "
          >
            <span>
              {selectedClient
                ? `${selectedClient.clientName} - ${selectedClient.locationName}, ${selectedClient.subLocationName}`
                : "Select client"}
            </span>

            <svg
              className={`w-4 h-4 transition-transform ${
                open ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {open && (
            <div
              className="
                absolute z-50 mt-2 w-full
                bg-white
                border border-gray-200
                rounded-lg
                shadow-lg
                max-h-64
                overflow-y-auto
              "
            >
              {clients.length === 0 && (
                <div className="px-2 py-1 text-sm text-gray-400">
                  No clients available
                </div>
              )}

              {clients.map((client) => (
                <div
                  key={client.clientID}
                  onClick={() => {
                    onClientChange(client);
                    setOpen(false);
                  }}
                  className="
                    p-2
                    cursor-pointer
                    hover:bg-gray-100
                    text-sm
                  "
                >
                  {client.clientName} - {client.locationName},{" "}
                  {client.subLocationName}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* CLIENT AVAILABILITY TOGGLE */}
      <div
        onClick={() => onToggleAvailability?.()}
        className="
          relative
          w-[72px]
          h-[24px]
          bg-gray-200
          rounded-[6px]
          cursor-pointer
          select-none
          flex
          items-center
          px-0.5
        "
      >
        <div
          className={`
            absolute top-[2px] bottom-[2px]
            w-[32px]
            rounded-[4px]
            transition-all duration-300 ease-in-out
            ${
              isClientAvailable
                ? "left-[2px] bg-green-600"
                : "left-[38px] bg-gray-500"
            }
          `}
        />

        <div className="relative z-10 flex w-full justify-between px-1.5 text-[10px] font-semibold">
          <span className={isClientAvailable ? "text-white" : "text-gray-500"}>
            ON
          </span>
          <span className={!isClientAvailable ? "text-white" : "text-gray-500"}>
            OFF
          </span>
        </div>
      </div>
      <button
        onClick={onLiveCounter}
        className="
            px-2 py-0.5
            border border-red-500
            text-red-500
            text-xs
            rounded
            font-medium
            hover:bg-red-50
            whitespace-nowrap
          "
      >
        Live Counter
      </button>
    </div>
  );
};

export default ClientBar;
